
import React, { Component } from 'react';
import './selectAreaPage.less';
import { Input } from "antd";
import { meshLog, SPGet, SPSet } from '../../../utils/spUtils';
import PubSub from 'pubsub-js'
import area from "../../../imgs/item/area.png";
import btn_del from "../../../imgs/btn/map_del.png";
import btn_edit from "../../../imgs/btn/btn_edit.png";
import close_btn from '../../../imgs/btn/close_btn.png';
import {  } from '../../../utils/meshUtils';
import search from '../../../imgs/item/icon_search.png';
import { AREA_create_area, Attention_Area, Attention_DIALOG_HIDE, Attention_DIALOG_SHOW } from '../../../const/infoConst';
import { changeSelectBuilding, deleteCurMesh } from '../../../utils/net/netUtils';

let cur_area="";
let temp_selct="";
export default class SelectAreaPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mList: [], 
            search_info:"",
        };
    }

    componentDidMount() {
        this.updatePageUI();
        PubSub.subscribe('changeMeshUpdateUI', (msg, data) => {
            this.updatePageUI();
        })
        PubSub.subscribe(Attention_DIALOG_HIDE, (msg, index) => {
            if(index==Attention_Area && cur_area.meshName==SPGet("delete_area_name")){
                meshLog('删除area', cur_area.meshName);
                deleteCurMesh(cur_area.meshUUID,cur_area.meshName);
            }  
        })
    }

    //搜索框
    searchChange= (event) => {
        let mm=event.target.value;
        meshLog('搜索',mm);
        this.setState({ search_info: mm });

        let lists = JSON.parse(SPGet("meshList"));
        let arr=[];
        let count=0;

        for (let i = 0; i < lists.length; i++) {
            let m1=(lists[i].meshName).toLowerCase();
            let m2=mm.toLowerCase();
            const has = m1.includes(m2);
            if(has){
                lists[i]["click"]=0;
                if(temp_selct.length>0 && m1==temp_selct){
                    lists[i]["click"]=1;
                }
                arr[count]=lists[i];
                count++;
            }
        }
        meshLog('arr', arr);
        this.setState({
            mList: arr,
        });
    };

    //刷新UI
    updatePageUI() {
        let lists = JSON.parse(SPGet("meshList"));
        meshLog('获取area', lists);
        for (let i = 0; i < lists.length; i++) {
            lists[i]["click"]=0;
            if(lists[i].meshName==SPGet("SelectMeshName")){
                lists[i]["click"]=1;
            }
        }
        temp_selct=SPGet("SelectMeshName");
        this.setState({
            mList: lists,
        });
    }

    //切换area
    areaChangeClick(item){
        cur_area=item;
        meshLog('切换area', item.meshName);
        let lists=this.state.mList;
        for (let i = 0; i < lists.length; i++) {
            lists[i].click=0;
            if(lists[i].meshName==item.meshName){
                lists[i].click=1;
            }
        }
        temp_selct=item.meshName;
        this.setState({
            mList: lists,
        });

    }

    //编辑area
    areaBtnEditClick(item){
        PubSub.publish("update_area_data_ui", item)//加载框
        this.props.onDataToParent(AREA_create_area);

    }

    //删除area
    areaBtnDeleteClick(item){
        this.areaChangeClick(item);
        SPSet("delete_area_name", item.meshName);
        PubSub.publish(Attention_DIALOG_SHOW,Attention_Area)
    }



    //取消弹窗
    sendDataToParent(){
        this.setState({search_info:""});
        this.updatePageUI();
        this.props.onDataToParent("");
    };

    //保存弹窗
    sendDataToParentOK(){
        this.props.onDataToParent("");
        if (cur_area.meshName == SPGet("SelectMeshName")) return;

        let buildname = SPGet("SelectBuildingName");
        changeSelectBuilding(buildname, cur_area.meshName); //需要从新获取meshList
    };



    render() {
        return (
            <div className="ui_dialog_bg">
                <div className="ui_grey_bg" />
                <div className="select_area_container" style={{left:(document.body.clientWidth-380)/2}}>
                    {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={this.sendDataToParent.bind(this)}/>
                    {/* 标题行 */}
                    <div className="item_row">
                        <div className="item_title">
                            <img src={area} />
                            <span>Select Area</span>
                        </div>
                    </div>

                    {/* 搜索框 */}
                    <Input className="search_item" prefix={<img src={search} style={{ width:16, height:16 }} />} placeholder="Enter your query" value={this.state.search_info} maxLength={15} onChange={this.searchChange}/>


                    {/* area列表 */}
                    <div className="area_list">
                        {this.state.mList.map((item) => (
                            <div className="area_item" key={item.meshUUID} style={{background:item.click==1?"#f3f3f3":"#ffffff"}}>
                                <span className='area_name' onClick={() => this.areaChangeClick(item)}>{item.meshName}</span>
                                <img className='area_btn_edit' style={{display: item.click==1?"flex":"none" }} src={btn_edit} onClick={() => this.areaBtnEditClick(item)} />
                                <img className='area_btn_del' style={{display: (item.click==1 && this.state.mList.length>1)?"flex":"none" }} src={btn_del} onClick={() => this.areaBtnDeleteClick(item)} />
                            </div>
                        ))}
                    </div>

                    {/* 底部按钮 */}
                    <div className="select_area_footer">
                        <button className='cancelBtn' onClick={this.sendDataToParent.bind(this)}>Cancel</button>
                        <button className='okBtn' onClick={this.sendDataToParentOK.bind(this)}>Confirm</button>
                    </div>


                </div>
            </div>

        );
    }
}
